import { useState } from 'react';
import { parse } from 'hub-http/helpers/params';
export const useShouldAutoFocusEditor = () => {
  const [shouldFocus] = useState(() => {
    const queryParams = parse(window.location.search.substring(1));
    return !(queryParams && queryParams.focusCallNotesEditor);
  });
  return shouldFocus;
};